module.exports = __webpack_public_path__ + "images/content/secure_file_backups.gif";